export const HOVER_EFFECT = {
  COLOR: "#338bff",
  FILL: "none",
  STROKE_WIDTH: 1,
  CLASSNAME: "absolute z-[1000] inset-0 pointer-events-none",
};
